import { InferType, object, string } from 'yup'

export const destinationSchema = object().shape({
    name: string().required('Nome obrigatório'),
})

export interface Destination extends InferType<typeof destinationSchema> {}
